module.exports = __webpack_public_path__ + "static/img/emblem.cc79909.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attestation/emblem.png
// module id = QpxK
// module chunks = 1